import { appointmentState } from './appointment.state';
import { appointmentActions } from './appointment.action';
import { appointmentMutations } from './appointment.mutation';

export default {
  namespaced: true,
  state: appointmentState,
  getters: {},
  actions: appointmentActions,
  mutations: appointmentMutations,
};
